import { Divider, VStack } from '@cad-arc';
import { useApiClient } from '~/api-client';
import { useQuery } from '@tanstack/react-query';
import { intersperse } from '../common/helpers/intersperse';
import { SavedUnitStatusSearch } from './saved-unit-status-search';
import { SavedSearches } from '../search-windows/saved-searches';
import { CadSearchsaveResource, UnitStatusSearchForm } from '@mark43/cad-api';
import { SavedSearchHandler } from '../fr-page-layout/search-pages/types';

export function UnitStatusSearchSavedSearches({
    onClose,
    onSavedSearchClick,
}: {
    onSavedSearchClick: SavedSearchHandler<UnitStatusSearchForm>;
    onClose?: () => void;
}) {
    const apiClient = useApiClient();
    const { data: unitStatusSearchGetResponse, isInitialLoading, isError, refetch } = useQuery(
        ['saved-unit-status-searches'],
        () => {
            return apiClient
                .request<CadSearchsaveResource.GetUnitStatusSearches>({
                    method: 'GET',
                    url: 'cad_search/save/unit_status',
                })
                .then((resp) => resp.data.data);
        }
    );
    const hasSavedSearches =
        !!unitStatusSearchGetResponse &&
        unitStatusSearchGetResponse.savedUnitStatusSearchDtos.length > 0;
    const isNoSavedSearches =
        !!unitStatusSearchGetResponse &&
        unitStatusSearchGetResponse.savedUnitStatusSearchDtos.length === 0;
    return (
        <SavedSearches
            hasSavedSearches={hasSavedSearches}
            isNoSavedSearches={isNoSavedSearches}
            isLoading={isInitialLoading}
            isError={isError}
            onClose={onClose}
        >
            <VStack align="left" w="100%">
                {intersperse(
                    unitStatusSearchGetResponse?.savedUnitStatusSearchDtos.map((savedSearch) => {
                        return (
                            <SavedUnitStatusSearch
                                onSavedSearchClick={onSavedSearchClick}
                                key={savedSearch.savedSearchId}
                                savedSearch={savedSearch}
                                refetchSavedSearches={refetch}
                            />
                        );
                    }) ?? [],
                    <Divider />
                )}
            </VStack>
        </SavedSearches>
    );
}
